import { render, staticRenderFns } from "./BtnFiltros.vue?vue&type=template&id=ac83c9dc&"
import script from "./BtnFiltros.vue?vue&type=script&lang=js&"
export * from "./BtnFiltros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports